import { Checkbox, Modal } from 'antd';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ModalConfirm = ({ open, setOpen, onFinish }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    setOpen(false);
    onFinish();
  };

  const contentRef = useRef(null);

  const handleCancel = () => {
    setOpen(false);
    setTermReaded(false);
    setTermsAccepted(false);
  };

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termReaded, setTermReaded] = useState(false);

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
  };

  const handleScroll = () => {
    if (
      contentRef.current &&
      contentRef.current.scrollHeight - contentRef.current.scrollTop <=
        contentRef.current.clientHeight + 1
    ) {
      setTermReaded(true);
    } else {
      if (!termsAccepted) {
        setTermReaded(false);
      }
    }
  };

  return (
    <Modal
      title={t('request_account.modalConfirm.title')}
      visible={open}
      onOk={handleConfirm}
      onCancel={handleCancel}
      okButtonProps={{ disabled: !termsAccepted }}
      width={800}
      destroyOnClose
      cancelText={t('request_account.modalConfirm.button.cancel')}
      okText={t('request_account.modalConfirm.button.ok')}
    >
      <div
        style={{
          maxHeight: '50vh',
          overflowY: 'auto',
          textAlign: 'justify',
          padding: '0 10px',
        }}
        ref={contentRef}
        onScroll={handleScroll}
        dangerouslySetInnerHTML={{
          __html: t('request_account.modalConfirm.message'),
        }}
      ></div>
      <Checkbox
        onChange={handleCheckboxChange}
        disabled={!termReaded}
        style={{
          display: 'block',
          textAlign: 'right',
        }}
      >
        {t('request_account.modalConfirm.checkbox')}
      </Checkbox>
    </Modal>
  );
};

export default ModalConfirm;
